/**
 * Created by Victor Rojo on 9/9/19.
 */
import { Component, OnDestroy, Input, QueryList, ViewChildren }     from '@angular/core';
import { Router, ActivatedRoute, Params }                   from '@angular/router';

import {Section, SectionMap} from "../section/Section";
import {Widget, WidgetTypes} from "../widget/Widget";
import {SectionService} from "../section/Section.service";
import {WidgetService} from "../widget/Widget.service";
import {IPlaceDataChangeService} from "../IPlaceDataChange.service";
import {HLSCameraComponent} from "../component/streaming/HLSCamera.component";


@Component({
  selector: 'iplace-section',
  templateUrl: './IPlaceSection.component.html',
  styleUrls: ['./IPlaceSection.component.css']
})
export class IPlaceSectionComponent implements OnDestroy{

  widgets: Widget[];
  WidgetTypes: any;
  isLoading = false;
  currentSection: Section;

  private iPlaceId:string;

  private _id:any;

  get id(): any {
    return this._id;
  }

  streamingActive = true;
  @ViewChildren('streaming') streamingComponents:QueryList<HLSCameraComponent>;

  @Input()
  set id(id: any) {
    this._id = id;
    this.loadIPlace(id);
  }

  constructor(
    private sectionService: SectionService,
    private widgetService: WidgetService
  ) {
    this.WidgetTypes = WidgetTypes;
  }

  loadIPlace(id: any){
    let iPlaceId = id.iPlaceId;
    let sectionId = id.sectionId;
    if ( this.iPlaceId != iPlaceId ) {
      this.iPlaceId = iPlaceId;
    }
    if ( sectionId != "null" ) {
      this.isLoading = true;
      this.loadWidgets(sectionId);
      this.loadSection(sectionId);
    } else {
      this.currentSection = null;
      this.widgets = [];

    }
  }

  private loadWidgets(sectionId: string) {
    this.widgetService.get(sectionId).then((widgets:Widget[]) => {
      this.widgets = widgets.sort( (w1,w2) => {
        if ( w1.positionY == w2.positionY) {
          return w1.positionX - w2.positionX;
        }
        return w1.positionY - w2.positionY;
      });
      this.isLoading = false;
    });

  }

  private loadSection(sectionId: string) {
    this.sectionService.getSection(sectionId).then( section => {
      this.currentSection = section;
    })
  }

  public setStreamingActive(active:boolean){
    this.streamingActive = active;
    if ( this.streamingComponents && this.streamingComponents.length ) {
      this.streamingComponents.forEach(function(hlsCamera){
        hlsCamera.streamingActive(active);
      })
    }
  }

  isElementGroupWidget(widgetTypeId: number) {
    if ( widgetTypeId == WidgetTypes.LIGHTS_ON
      || widgetTypeId == WidgetTypes.NETWORK_DEVICES
      || widgetTypeId == WidgetTypes.SOCKETS_ON
      || widgetTypeId == WidgetTypes.STATUS_GROUP) {
      return true;
    }
    return false;
  }

  public ngOnDestroy(): void {
  }
}
